"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var VisitsApi = /** @class */ (function (_super) {
    __extends(VisitsApi, _super);
    function VisitsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Use this endpoint to send a notification email for a `Visit`.
     * Send a notification email for a visit
     */
    VisitsApi.prototype.actionSendVisitNotificationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.visitId === null || requestParameters.visitId === undefined) {
                            throw new runtime.RequiredError('visitId', 'Required parameter requestParameters.visitId was null or undefined when calling actionSendVisitNotification.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/visits/{visitId}/send".replace("{" + "visitId" + "}", encodeURIComponent(String(requestParameters.visitId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SendVisitNotificationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to send a notification email for a `Visit`.
     * Send a notification email for a visit
     */
    VisitsApi.prototype.actionSendVisitNotification = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionSendVisitNotificationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to create a new `Visit`.
     * Create a new visit
     */
    VisitsApi.prototype.createNewVisitRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/visits",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateVisitRequestToJSON(requestParameters.createVisitRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowVisitResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to create a new `Visit`.
     * Create a new visit
     */
    VisitsApi.prototype.createNewVisit = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createNewVisitRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to create a guest for a `Visit`.
     * Create a guest for a visit
     */
    VisitsApi.prototype.createVisitGuestRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.visitId === null || requestParameters.visitId === undefined) {
                            throw new runtime.RequiredError('visitId', 'Required parameter requestParameters.visitId was null or undefined when calling createVisitGuest.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/visits/{visitId}/guests".replace("{" + "visitId" + "}", encodeURIComponent(String(requestParameters.visitId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateVisitGuestRequestToJSON(requestParameters.createVisitGuestRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.VisitGuestResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to create a guest for a `Visit`.
     * Create a guest for a visit
     */
    VisitsApi.prototype.createVisitGuest = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createVisitGuestRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Remove a visit
     * Remove a visit
     */
    VisitsApi.prototype.deleteVisitRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.visitId === null || requestParameters.visitId === undefined) {
                            throw new runtime.RequiredError('visitId', 'Required parameter requestParameters.visitId was null or undefined when calling deleteVisit.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/visits/{visitId}".replace("{" + "visitId" + "}", encodeURIComponent(String(requestParameters.visitId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Remove a visit
     * Remove a visit
     */
    VisitsApi.prototype.deleteVisit = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteVisitRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Remove a visit guest
     * Remove a visit guest
     */
    VisitsApi.prototype.deleteVisitGuestRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.visitId === null || requestParameters.visitId === undefined) {
                            throw new runtime.RequiredError('visitId', 'Required parameter requestParameters.visitId was null or undefined when calling deleteVisitGuest.');
                        }
                        if (requestParameters.guestId === null || requestParameters.guestId === undefined) {
                            throw new runtime.RequiredError('guestId', 'Required parameter requestParameters.guestId was null or undefined when calling deleteVisitGuest.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/visits/{visitId}/guests/{guestId}".replace("{" + "visitId" + "}", encodeURIComponent(String(requestParameters.visitId))).replace("{" + "guestId" + "}", encodeURIComponent(String(requestParameters.guestId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Remove a visit guest
     * Remove a visit guest
     */
    VisitsApi.prototype.deleteVisitGuest = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteVisitGuestRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a list `Visits` for a `Customer`.
     * Show visits for a customer
     */
    VisitsApi.prototype.getCustomerVisitsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getCustomerVisits.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/visits/{customerId}/customer".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListVisitsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a list `Visits` for a `Customer`.
     * Show visits for a customer
     */
    VisitsApi.prototype.getCustomerVisits = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerVisitsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to get a single `Visit`.
     * Get a single visit.
     */
    VisitsApi.prototype.getVisitRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.visitId === null || requestParameters.visitId === undefined) {
                            throw new runtime.RequiredError('visitId', 'Required parameter requestParameters.visitId was null or undefined when calling getVisit.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/visits/{visitId}".replace("{" + "visitId" + "}", encodeURIComponent(String(requestParameters.visitId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowVisitResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to get a single `Visit`.
     * Get a single visit.
     */
    VisitsApi.prototype.getVisit = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVisitRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to get a paged list of `Visit`s for the current site.
     * Get a paged list of visits for the current site.
     */
    VisitsApi.prototype.getVisitsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.archived !== undefined) {
                            queryParameters['archived'] = requestParameters.archived;
                        }
                        if (requestParameters.arrivalDateFrom !== undefined) {
                            queryParameters['arrival_date_from'] = requestParameters.arrivalDateFrom.toISOString().substr(0, 10);
                        }
                        if (requestParameters.arrivalDateTo !== undefined) {
                            queryParameters['arrival_date_to'] = requestParameters.arrivalDateTo.toISOString().substr(0, 10);
                        }
                        if (requestParameters.createdAtDateFrom !== undefined) {
                            queryParameters['created_at_date_from'] = requestParameters.createdAtDateFrom.toISOString().substr(0, 10);
                        }
                        if (requestParameters.createdAtDateTo !== undefined) {
                            queryParameters['created_at_date_to'] = requestParameters.createdAtDateTo.toISOString().substr(0, 10);
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['per_page'] = requestParameters.perPage;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/visits",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListVisitsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to get a paged list of `Visit`s for the current site.
     * Get a paged list of visits for the current site.
     */
    VisitsApi.prototype.getVisits = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVisitsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint retrieves a list of smart filters for the visits list.
     * Get a list of smart filters for the visits list.
     */
    VisitsApi.prototype.getVisitsSmartFiltersRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling getVisitsSmartFilters.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/visits/smart-filters",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SmartFiltersResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint retrieves a list of smart filters for the visits list.
     * Get a list of smart filters for the visits list.
     */
    VisitsApi.prototype.getVisitsSmartFilters = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVisitsSmartFiltersRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates an existing visit.
     * Update a visit
     */
    VisitsApi.prototype.updateVisitRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.visitId === null || requestParameters.visitId === undefined) {
                            throw new runtime.RequiredError('visitId', 'Required parameter requestParameters.visitId was null or undefined when calling updateVisit.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/visits/{visitId}".replace("{" + "visitId" + "}", encodeURIComponent(String(requestParameters.visitId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateVisitRequestToJSON(requestParameters.updateVisitRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowVisitResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates an existing visit.
     * Update a visit
     */
    VisitsApi.prototype.updateVisit = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateVisitRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates an existing visit guest.
     * Update a visit guest
     */
    VisitsApi.prototype.updateVisitGuestRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.visitId === null || requestParameters.visitId === undefined) {
                            throw new runtime.RequiredError('visitId', 'Required parameter requestParameters.visitId was null or undefined when calling updateVisitGuest.');
                        }
                        if (requestParameters.guestId === null || requestParameters.guestId === undefined) {
                            throw new runtime.RequiredError('guestId', 'Required parameter requestParameters.guestId was null or undefined when calling updateVisitGuest.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/visits/{visitId}/guests/{guestId}".replace("{" + "visitId" + "}", encodeURIComponent(String(requestParameters.visitId))).replace("{" + "guestId" + "}", encodeURIComponent(String(requestParameters.guestId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateVisitGuestRequestToJSON(requestParameters.updateVisitGuestRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.VisitGuestResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates an existing visit guest.
     * Update a visit guest
     */
    VisitsApi.prototype.updateVisitGuest = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateVisitGuestRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return VisitsApi;
}(runtime.BaseAPI));
exports.VisitsApi = VisitsApi;
/**
    * @export
    * @enum {string}
    */
var GetVisitsStatusEnum;
(function (GetVisitsStatusEnum) {
    GetVisitsStatusEnum["Incomplete"] = "incomplete";
    GetVisitsStatusEnum["Configured"] = "configured";
    GetVisitsStatusEnum["Cancelled"] = "cancelled";
})(GetVisitsStatusEnum = exports.GetVisitsStatusEnum || (exports.GetVisitsStatusEnum = {}));
